function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

//自定义：to top悬浮按钮
class BackToTopButton extends HTMLElement {
  constructor() {
    super()
    this.handleScroll = this.handleScroll.bind(this)
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" })
    })
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const viewportHeight = window.innerHeight
    const scrollPosition = window.scrollY || document.documentElement.scrollTop
    if (scrollPosition > viewportHeight + 280) {
      this.classList.add("show")
    } else {
      this.classList.remove("show")
    }
  }
}

if (!window.customElements.get("back-to-top-button")) {
  customElements.define("back-to-top-button", BackToTopButton)
}

//自定义：产品页附加产品功能
class AdditionalProducts extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.registerClickEvents()
    this.jointName()//默认先展示一次None
  }
  registerClickEvents(){
    this.querySelectorAll(".product-block-wrap").forEach((item)=>{
      item.addEventListener("click", ()=>{
        if(item.classList.contains("active")){
          item.classList.remove("active")
        }else{
          item.classList.add("active")
        }
        this.jointName()
      })
    })
  }
  jointName(){
    const allActiveWraps = this.querySelectorAll(".product-block-wrap.active")
    const optionValue = this.querySelector(".option-value")
    let jointText = Array.from(allActiveWraps).reduce((prev,item)=>{
      const title = item.querySelector(".title").innerText + " / "
      return prev += title
    },'')
    if(jointText.length > 0) {
      jointText = jointText.slice(0,-3)
    }
    optionValue.innerText = jointText || "None"
  }
}

if (!window.customElements.get("additional-products")) {
  customElements.define("additional-products", AdditionalProducts)
}

/* 
参数：
white-modal-id：white-modal的id，等于white-modal.liquid的modal_type参数
pc-modal-id：pc-modal的id，等于pc-modal.liquid的modal_type参数
white-modal-height-factor：white-modal的高度因子，通常是0 - 1之间的小数

inner-id: 如果是多个内容共用弹窗的话，那具体展示哪个内容，需要通过此id指定
*/
class dialogButton extends HTMLElement {
  constructor() {
    super()
    // 绑定this
    this.initPhoneWhiteModal = this.initPhoneWhiteModal.bind(this)
    this.commonModal = this.hasAttribute("common-modal")
    if(this.commonModal) {
      this.h5CommonModalShowDom = document.querySelector(`.white-modal #${this.getAttribute("inner-id")}`)
      this.pcCommonModalShowDom = document.querySelector(`pc-modal #${this.getAttribute("inner-id")}`)
    } else {
      this.h5CommonModalShowDom = document.querySelector("#h5-comparison-modal")
    }

    this.whiteModalId = this.getAttribute("white-modal-id")
    this.pcModalId = this.getAttribute("pc-modal-id")
    this.whiteModalHeightFactor = parseFloat(this.getAttribute("white-modal-height-factor")) || 0.15

    // 缓存DOM元素，避免重复查询
    this.modal = document.querySelector(`#${this.whiteModalId}`)
    this.modalContent = this.modal.querySelector(".white-modal-content")
    this.modalInner = this.modal.querySelector(".white-modal-inner")

    // 业务逻辑
    this.addEventListener("click", this.handleClick)
    this.initPhoneWhiteModal()
  }
  
  initPhoneWhiteModal() {
    const _this = this
    this.modal.addEventListener("click", function (event) {
      // 检查点击是否在 .white-modal-content 区域之外
      if (!event.target.closest(".white-modal-content") || event.target.closest(".white-modal-close")) {
        _this.closePhoneWhiteModal()
      }
    })
    this.modalContent.addEventListener("scroll", function (event) {
      event.stopPropagation()
      if (event.cancelable) {
        event.preventDefault()
      }
    })
  }

  handleClick() {
    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches
    if (isMobile) {
      this.openPhoneWhiteModal()
      document.body.style.overflow = 'hidden';
    } else {
      this.openPcModal()
    }
  }
  openPcModal() {
    this.listenPcModalClose()
    const pcModal = document.querySelector(`#${this.pcModalId}`)
    if(this.commonModal) {
      this.pcCommonModalShowDom.classList.remove("hidden")
    }
    if (pcModal) {
      pcModal.style.display = "block"
    }
  }
  listenPcModalClose() {
    document.addEventListener("dialog:close", (info)=>{
      console.log("info.detail.dialogType:",info.detail.dialogType)
      if(info.detail.dialogType == this.getAttribute("pc-modal-type")){
        this.pcCommonModalShowDom.classList.add("hidden")
      }
    })
  }
  openPhoneWhiteModal() {
    if(this.commonModal) {
      this.h5CommonModalShowDom.classList.remove("hidden")
    }
    this.modal.style.display = "block"

    setTimeout(() => {
      // 计算顶部位置
      let viewportHeight = window.innerHeight
      let modalTopAttrValue = viewportHeight * this.whiteModalHeightFactor
      // 应用计算后的顶部位置
      this.modalContent.style.top = modalTopAttrValue + "px"
    }, 10) // 小的超时来触发过渡
  }

  closePhoneWhiteModal() {
    document.body.style.overflow = "unset";
    this.modalContent.style.top = "100%"
    setTimeout(() => {
      this.h5CommonModalShowDom.classList.add("hidden")
      this.modal.style.display = "none"
    }, 300) // 与CSS过渡时间匹配
  }
}

// 注册自定义元素
if (!window.customElements.get("dialog-button")) {
  customElements.define("dialog-button", dialogButton)
}

class PcModal extends HTMLElement {
  constructor() {
    super()
    this._modal = this.querySelector(".modal-content")
    this.modalType = this.getAttribute("modal-type")
    this._closeButton = this.querySelector(".close")
    // 打开和关闭模态框的功能
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    // 监听关闭按钮的点击事件
    if (this._closeButton) {
      this._closeButton.addEventListener("click", this.close)
    }

    // 监听点击模态框外部时关闭模态框
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close()
      }
    })
  }

  // 打开模态框
  open() {
    this.style.display = "block"
    this._modal.classList.remove("modal-hide")
  }

  // 关闭模态框
  close() {
    if(this.modalType){
      const event = new CustomEvent("dialog:close",{
        detail: {
          dialogType: this.modalType
        },
      })
      document.dispatchEvent(event) // 触发事件
    }
    this.style.display = "none"
  }
}
if (!window.customElements.get("pc-modal")) {
  // 定义自定义元素
  customElements.define("pc-modal", PcModal)
}

/* media-compose-marquee中用到了video，该组件开启自动播放 */
class videoBesideMaquee extends HTMLElement {
  constructor() {
    super()
    if(this.hasAttribute("autoplay")) {
      setTimeout(() => {
        this._playVideo()
      }, 0);
    }
  }
  _playVideo(){
    this.videoMedia = this.querySelector("video-media")
    this.videoMedia.play({ restart: true });
  }
}
if (!window.customElements.get("video-beside-maquee")) {
  // 定义自定义元素
  customElements.define("video-beside-maquee", videoBesideMaquee)
}

// js/development/sliderTabs.js
import { animate as animate50 } from "vendor";
var sliderTabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
    document.addEventListener("swiperOfSliderTabs:change", debounce(this._changeTabByIndex.bind(this), 300));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => {
      this.selectedIndex = index
      const event = new CustomEvent("sliderTabs:change", {
        detail: {
          index: index,
        },
      })
      document.dispatchEvent(event) // 触发事件
    }, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transitionTab(this.slider, parseInt(newValue));
      this._transitionContent(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  _changeTabByIndex(event) {
    const index = event.detail.index;
    if (index >= 0 && index < this.buttons.length) {
      this.selectedIndex = index;
    }
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transitionTab(slider, toIndex) {
    await animate50(slider, { x: `${toIndex * 100}%` }, { duration: 0.3, easing: "ease-in-out" }).finished;
  }
  async _transitionContent(fromPanel, toPanel) {
    await animate50(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate50(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("slider-tabs")) {
  window.customElements.define("slider-tabs", sliderTabs);
}

// js/development/sliderTabsPcCarousel.js
// 将轮播图抽到单独的组件中【其实就应该这样抽，但是代码当中有一些是<script></script>去弄的】
var sliderTabsPcCarousel = class extends HTMLElement {
  constructor() {
    super();
    this.actualSlideNum = parseInt(this.getAttribute("actual-slide-num"));
    this.stretchValue = parseInt(this.getAttribute("stretch-value")) || -120
    document.addEventListener("sliderTabs:change", this._changeSlideByIndex.bind(this));
    if(!window.matchMedia("(max-width: 767px)").matches) {
      this.targetSwiper = this._initPcSwiper();
      this._listenSwiperChange(this.targetSwiper);
    }
  }
  _initPcSwiper() {
    const targetDom = this.querySelector(".swiper-container");
    if(!targetDom) return null;
    return new Swiper(targetDom, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 1.5, // ✅ 显示1.5个slide，两边各漏一点
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: this.stretchValue, // ✅ 负值让两侧图片稍微收缩
        depth: 800,
        modifier: 1,
        slideShadows: true, // ✅ 关闭阴影，按需调整
      },
    });
  }
  _listenSwiperChange(targetSwiper) {
    const tempActualSlideNum = this.actualSlideNum
    targetSwiper.on('realIndexChange', function () {
      const event = new CustomEvent("swiperOfSliderTabs:change", {
        detail: { //因为swiper在3个slide的时候，存在bug时，所以liquid中处理了代码，同时这里也要处理。
          index: tempActualSlideNum > 3 ? targetSwiper.realIndex : (targetSwiper.realIndex % tempActualSlideNum),
        },
      });
      document.dispatchEvent(event); // 触发事件
    });
  }
  _changeSlideByIndex(event) {
    const index = event.detail.index;
    if(this.targetSwiper) {
      this.targetSwiper.slideToLoop(index);
    }
  }
}
if (!window.customElements.get("slider-tabs-pc-carousel")) {
  window.customElements.define("slider-tabs-pc-carousel", sliderTabsPcCarousel);
}

var variantSwitchDeliveryInterests = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.prevTargetEleClass = ""
    this._variantPickerChange();
    // 动态计算到货时间
    this._dynamicCalcArrivalTime();
  }
  _variantPickerChange() {
    let formElement = document.querySelector('.product-info__buy-buttons>.shopify-product-form');
    let idInput = formElement.querySelector('input[name="id"]');
    idInput.addEventListener('change', (event) => {
      this._handleArrivalTimeShow(event.target.value)
    });
    this._handleArrivalTimeShow(idInput.value)
  }
  _handleArrivalTimeShow(variantId) {
    if(this.prevTargetEleClass){
      const prevTargetEle = document.querySelector(this.prevTargetEleClass)
      if(prevTargetEle) prevTargetEle.style.display = "none"
    }
    const targetEleClass = `.dev-interests-wrap.belong_${variantId}`
    const targetEle = this.querySelector(targetEleClass)
    if(targetEle) {
      this.prevTargetEleClass = targetEleClass
      targetEle.style.display = "flex"
    } else {
      const targetEle = this.querySelector(".default-interests-wrap")
      this.prevTargetEleClass = ".dev-interests-wrap.default-interests-wrap"
      targetEle.style.display = "flex"
    }
  }
  _dynamicCalcArrivalTime() {
    //开始处理时间计算问题:
    const deliveryTimeEles = Array.from(this.querySelectorAll('.delivery-interests-delivery-time')) || []
    console.log("deliveryTimeEles:",deliveryTimeEles)
    if(!deliveryTimeEles||deliveryTimeEles.length == 0) return
    const date = new Date();
    const months = [
      'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];

    // 计算 1 天后和 4 天后的日期
    const oneDayLater = new Date(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    const fourDaysLater = new Date(date.getTime() + 4 * 24 * 60 * 60 * 1000);

    const oneDayLaterDay = oneDayLater.getDate();
    const oneDayLaterMonth = months[oneDayLater.getMonth()];
    const oneDayLaterFormattedDate = `${oneDayLaterDay}. ${oneDayLaterMonth}`;

    const fourDaysLaterDay = fourDaysLater.getDate();
    const fourDaysLaterMonth = months[fourDaysLater.getMonth()];
    const fourDaysLaterFormattedDate = `${fourDaysLaterDay}. ${fourDaysLaterMonth}`;
    const finalStr = oneDayLaterFormattedDate + ' bis zum ' + fourDaysLaterFormattedDate;
    deliveryTimeEles.forEach((deliveryTime) => {
      deliveryTime.innerHTML = finalStr;
    })
  }
}
if (!window.customElements.get("variant-switch-delivery-interests")) {
  window.customElements.define("variant-switch-delivery-interests", variantSwitchDeliveryInterests);
}


// 左侧菜单切换右侧内容的自定义元素
class leftSwitchMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.triggerType = this.getAttribute('trigger-type') || 'click';
    this.init();
  }

  init() {
    // 获取所有左侧菜单项
    this.menuItems = this.querySelectorAll('.left-menu-item');
    // 获取所有右侧面板
    this.panels = this.querySelectorAll('.second-third-level-panel');
    
    // 根据触发类型添加不同的事件监听
    if (this.triggerType === 'hover') {
      this.menuItems.forEach(item => {
        item.addEventListener('mouseenter', this.handleMenuItemClick.bind(this, item));
      });
    } else {
      this.menuItems.forEach(item => {
        item.addEventListener('click', this.handleMenuItemClick.bind(this, item));
      });
    }
  }

  handleMenuItemClick(clickedItem) {
    // 获取点击的菜单项索引
    const index = clickedItem.dataset.index;
    
    // 移除所有菜单项的active类
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });
    
    // 为点击的菜单项添加active类
    clickedItem.classList.add('active');
    
    // 隐藏所有面板
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // 显示对应的面板
    const targetPanel = this.querySelector(`.second-third-level-panel[data-panel-index="${index}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      
      // 添加动画效果
      this.animatePanelChange(targetPanel);
    }
  }
  
  animatePanelChange(panel) {
    // 为面板添加简单的淡入效果
    panel.style.opacity = '0';
    panel.style.transform = 'translateY(10px)';
    
    // 使用requestAnimationFrame确保DOM更新后再应用动画
    requestAnimationFrame(() => {
      panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
      
      // 清除过渡效果，以便下次切换
      setTimeout(() => {
        panel.style.transition = '';
      }, 300);
    });
  }
}

if (!window.customElements.get('left-switch-mega-menu')) {
  customElements.define('left-switch-mega-menu', leftSwitchMegaMenu);
}

// 左侧菜单切换右侧内容的自定义元素
class localizationSelector extends HTMLElement {

  /**
   * Helper function to get a cookie by name.
   * @param {string} name The name of the cookie.
   * @returns {string|null} The cookie value or null if not found.
   */
  _getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  /**
   * Helper function to set a cookie.
   * @param {string} name The name of the cookie.
   * @param {string} value The value of the cookie.
   * @param {number} [days=7] The number of days until the cookie expires.
   */
  _setCookie(name, value, days = 7) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Set path=/ to make the cookie available site-wide
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  /**
   * Checks if the affiliate tracking ID exists in the URL query string.
   * If it does, store it in our own cookie for immediate access.
   */
  handleUrlQueryToCookie() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const imRefValue = urlParams.get('im_ref');

      if (imRefValue) {
        console.log(`Found 'im_ref' in URL, setting 'selfhandle_irclickid' cookie.`);
        this._setCookie('selfhandle_irclickid', imRefValue);
      }
    } catch (e) {
      console.error("Error processing URL parameters:", e);
    }
  }

  /**
   * Called when the element is added to the DOM.
   */
  connectedCallback() {
    // 1. 立即检查URL参数并设置我们自己的cookie
    this.handleUrlQueryToCookie();

    // 2. 开始轮询，以寻找我们自己的cookie或第三方设置的cookie
    this._pollForAffiliateId();
  }

  /**
   * Polls for either 'selfhandle_irclickid' or 'irclickid' cookie.
   */
  _pollForAffiliateId() {
    const pollInterval = 100; // Check every 100ms
    const maxDuration = 6000; // Stop after 6 seconds
    const startTime = Date.now();

    const intervalId = setInterval(() => {
      // 检查我们自己设置的cookie或第三方设置的cookie
      const selfHandledId = this._getCookie('selfhandle_irclickid');
      const thirdPartyId = this._getCookie('irclickid');
      
      const finalId = selfHandledId || thirdPartyId;

      // --- Success Condition ---
      // 如果任意一个cookie存在，则停止轮询并重写链接
      if (finalId) {
        clearInterval(intervalId);
        console.log(`Affiliate ID found: ${finalId}. Ceasing poll.`);
        this._rewriteLinks(finalId);
        return;
      }

      // --- Timeout Condition ---
      // 如果6秒已过，则停止轮询
      if (Date.now() - startTime > maxDuration) {
        clearInterval(intervalId);
        console.warn('Polling for affiliate ID timed out after 6 seconds.');
      }
    }, pollInterval);
  }

  /**
   * Rewrites the links with the affiliate tracking parameter.
   * @param {string} affiliateId The affiliate ID found.
   */
  _rewriteLinks(affiliateId) {
    const urlsToRewrite = [
      'https://deerruntreadmill.com',
      'https://ca.deerruntreadmill.com',
    ];

    this.querySelectorAll('.popover-listbox__option').forEach(link => {
      try {
        if (link.href && (link.href.startsWith('http:') || link.href.startsWith('https://'))) {
          const url = new URL(link.href);
          if (urlsToRewrite.includes(url.origin)) {
            url.searchParams.set('im_ref', affiliateId);
            link.href = url.toString();
          }
        }
      } catch (e) {
        console.error(`Invalid URL for localization selector: ${link.href}`, e);
      }
    });
  }
}

// 确保自定义元素被定义
if (!customElements.get('localization-selector')) {
  customElements.define('localization-selector', localizationSelector);
}

// js/development/pcH5Carousel.js （直接搬运自美区）
// h5-show-num：一屏展示多少张图片
// h5-picture-gap：图片间距
// carousel-speed：轮播速度
var pcH5Carousel = class extends HTMLElement {
  constructor() {
    super();
    if(window.matchMedia("(max-width: 767px)").matches) {
      this._initH5Swiper();
    } else {
      this._initPcSwiper();
    }
  }
  _initH5Swiper() {
    const h5CarouselDom = this.querySelector('.h5-swiper-container');
    if (!h5CarouselDom) return;

    // 获取属性值并设置默认值
    const slidesPerView = parseFloat(this.getAttribute('h5-show-num')) || 1;
    const spaceBetween = parseInt(this.getAttribute('h5-picture-gap')) || 0;
    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    // 基础配置
    const config = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    // 处理自动轮播
    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
      };
    }

    // 初始化 Swiper
    new Swiper(h5CarouselDom, config);
  }
  _initPcSwiper() {
    const pcCarouselDom = this.querySelector('.swiper-container');
    if (!pcCarouselDom) return;

    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    const config = {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
          loop: false,
          coverflowEffect: {
            rotate: 0,
            depth: 100,
            slideShadows: false,
          },
        },
        768: {
          slidesPerView: "auto",
          loop: true,
          coverflowEffect: {
            rotate: 0,
            depth: 300,
            slideShadows: true,
          },
        },
      },
    };

    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(pcCarouselDom, config);
  }
}

if (!window.customElements.get("pc-h5-carousel")) {
  window.customElements.define("pc-h5-carousel", pcH5Carousel);
}

// 新的附加产品组件
class NewAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
  }

  connectedCallback() {
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
  }
  
  setupExpandCollapseButton() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '30px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      wrapper.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 30;
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = false;
    wrapper.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = true;
    wrapper.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');
    
    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `${formattedPrice} €`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `${formattedComparePrice} €`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;

    // 检查内容是否产生滚动
    const scrollHeight = this.scrollHeight;
    const clientHeight = this.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      wrapper.classList.add('show-gradient');
    } else {
      wrapper.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelect = item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

// 注册自定义元素
if (!window.customElements.get('new-additional-products')) {
  customElements.define('new-additional-products', NewAdditionalProducts);
}

// 倒计时 + 优惠券复制 分区（sections/coupons-with-countdown.liquid）
class CountdownCouponsSection extends HTMLElement {
  constructor() {
    super();
    this._tick = this._tick.bind(this);
    this._handleCopyClick = this._handleCopyClick.bind(this);
  }
  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id') || '';
    this.expireAtStr = (this.getAttribute('data-expire-at') || '').trim();

    // 倒计时节点
    this.daysEl = this.querySelector('[data-time="days"]');
    this.hoursEl = this.querySelector('[data-time="hours"]');
    this.minutesEl = this.querySelector('[data-time="minutes"]');
    this.secondsEl = this.querySelector('[data-time="seconds"]');
    this.daysItem = this.querySelector('[data-days-item]');
    this.hoursItem = this.querySelector('[data-hours-item]');
    this.colons = this.querySelectorAll('.ccs__timer-colon');

    // 初始化倒计时（本地存储一个结束时间，避免刷新立刻重置）
    this._initCountdown();

    // 绑定复制按钮并记录初始文案
    this.querySelectorAll('.ccs__copy-btn').forEach((btn) => {
      if (!btn.dataset.btnOriginal) {
        btn.dataset.btnOriginal = (btn.textContent || '').trim();
      }
      btn.addEventListener('click', this._handleCopyClick);
    });
  }
  disconnectedCallback() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
    this.querySelectorAll('.ccs__copy-btn').forEach((btn) => {
      btn.removeEventListener('click', this._handleCopyClick);
      if (btn._ccsRevertTimer) {
        clearTimeout(btn._ccsRevertTimer);
        btn._ccsRevertTimer = null;
      }
    });
  }
  _initCountdown() {
    // 无有效到期时间则不计时（不做格式判断，仅判断是否存在）
    if (!this.expireAtStr) return;
    this._endTime = this._parseExpireAt(this.expireAtStr).getTime();
    this._tick();
    this._timer = setInterval(this._tick, 1000);
  }
  _tick() {
    if (!this._endTime) return;
    const now = Date.now();
    let diff = Math.max(0, this._endTime - now);

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    // 动态隐藏 Days / Hours：当 Days>0 时，Hours 也应该展示（即便为 00）
    // Minutes / Seconds 永远显示
    const showDays = days > 0;
    const showHours = showDays || hours > 0;
    if (this.daysItem) this.daysItem.style.display = showDays ? '' : 'none';
    if (this.hoursItem) this.hoursItem.style.display = showHours ? '' : 'none';
    if (this.colons && this.colons.length) {
      const colonAfterDays = this.colons[0];
      const colonAfterHours = this.colons[1];
      if (colonAfterDays) colonAfterDays.style.display = showDays ? '' : 'none';
      if (colonAfterHours) colonAfterHours.style.display = (showDays || showHours) ? '' : 'none';
    }

    if (totalSeconds <= 0 && this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
  _parseExpireAt(str) {
    // 格式保证为 yyyy-MM-dd HH:mm:ss，直接转为 ISO 本地时间格式
    return new Date(String(str).replace(' ', 'T'));
  }
  async _handleCopyClick(event) {
    const btn = event.currentTarget;
    if (btn.disabled || btn.classList.contains('is-disabled')) return;
    const wrapper = btn.closest('.ccs__card');
    if (!wrapper) return;

    const code = btn.getAttribute('data-clipboard') || '';
    const afterText = (btn.getAttribute('data-after-text') || '').trim();
    const btnAfterText = (btn.getAttribute('data-btn-after-text') || '').trim();

    try {
      await this._copyToClipboard(code);
    } catch (e) {
      // 忽略错误，仍然进行 UI 更新
    }

    // 替换左侧文本
    const beforeEl = wrapper.querySelector('.ccs__discount--before');
    const afterEl = wrapper.querySelector('.ccs__discount--after');
    if (afterText && beforeEl && afterEl) {
      beforeEl.hidden = true;
      afterEl.hidden = false;
      afterEl.textContent = afterText;
    }

    // 按钮文本替换，并在2秒后恢复
    if (btnAfterText) {
      btn.textContent = btnAfterText;
      const originalText = (btn.dataset.btnOriginal || '').trim();
      if (originalText) {
        if (btn._ccsRevertTimer) clearTimeout(btn._ccsRevertTimer);
        btn._ccsRevertTimer = setTimeout(() => {
          btn.textContent = originalText;
          btn._ccsRevertTimer = null;
        }, 2000);
      }
    }
  }
  _copyToClipboard(text) {
    // 优先使用现代 API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // 兼容处理（参考 coupon.liquid 思路）
    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand copy failed'));
      } catch (err) {
        reject(err);
      }
    });
  }
}

if (!window.customElements.get('countdown-coupons-section')) {
  customElements.define('countdown-coupons-section', CountdownCouponsSection);
}


// 自定义：折扣码复制横幅
class DiscountCodeBanner extends HTMLElement {
  constructor() {
    super();
    this._copyBtn = null;
    this._handleCopy = this._handleCopy.bind(this);
  }

  connectedCallback() {
    this._copyBtn = this.querySelector('.discount-banner__copy-btn');
    if (this._copyBtn) {
      this._copyBtn.addEventListener('click', this._handleCopy);
    }
  }

  disconnectedCallback() {
    if (this._copyBtn) {
      this._copyBtn.removeEventListener('click', this._handleCopy);
    }
  }

  async _handleCopy(event) {
    const btn = event.currentTarget;
    const discountCode = btn.getAttribute('data-discount-code');
    
    if (!discountCode) return;

    try {
      // 尝试使用现代 Clipboard API
      await navigator.clipboard.writeText(discountCode);
      this._showCopiedState(btn);
    } catch (err) {
      // 降级方案：使用 textarea 方法
      this._fallbackCopy(discountCode, btn);
    }
  }

  _fallbackCopy(text, btn) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this._showCopiedState(btn);
      } else {
        console.error('Copy command failed');
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    
    document.body.removeChild(textArea);
  }

  _showCopiedState(btn) {
    // 添加 copied 状态
    btn.classList.add('copied');
    
    // 2.5秒后移除 copied 状态
    setTimeout(() => {
      btn.classList.remove('copied');
    }, 2500);
  }
}

if (!window.customElements.get('discount-code-banner')) {
  customElements.define('discount-code-banner', DiscountCodeBanner);
}

class OfpPrice extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._modalCalled = false;
    this._onGlobalBeginCountdown = this._onGlobalBeginCountdown.bind(this);
    this._countdownRAF = null;
    this._countdownEndTime = null;
    this._hasTriggeredModal = 0;
  }
  connectedCallback() {
    this._cacheEls();
    this._installments = parseInt(this.getAttribute('data-installments')) || 0;
    this._price = this._safeParseMoney(this.getAttribute('data-price'));
    this._comparePrice = this._safeParseMoney(this.getAttribute('data-compare-price'));
    this._savings = this._safeParseMoney(this.getAttribute('data-savings')) || 0;
    this._countdownMinutes = parseInt(this.getAttribute('data-countdown-minutes')) || 0;
    this._countdownLabel = this.getAttribute('data-countdown-label') || '';
    // 从 Local Storage 读取 modal 触发状态
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
          this._hasTriggeredModal = parseInt(storedValue) || 0;
        }
      } catch (e) {
        console.error('Failed to read from localStorage:', e);
      }
    }
    
    this.addEventListener('ofp:switch-to-final', () => this._switchToFinal());
    this.addEventListener('ofp:begin-countdown', (e) => this.beginCountdown((e && e.detail) || {}));
    document.addEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);
    setTimeout(this._onScroll, 0);
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    document.removeEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
  }
  triggerModal() {
    const event = new CustomEvent("open-coupon-modal");
    const modal = document.querySelector('script-trigger-modal[listen-event="open-coupon-modal"]');
    modal.dispatchEvent(event);
    
    // 保存到 Local Storage
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        localStorage.setItem(storageKey, '1');
        this._hasTriggeredModal = 1;
      } catch (e) {
        console.error('Failed to write to localStorage:', e);
      }
    }
  }
  _getProductHandle() {
    // 从 URL 中提取 product handle
    // 例如: http://127.5.3.5:9292/products/deerrun-plus-walkingpad-treadmill
    // 返回: deerrun-plus-walkingpad-treadmill
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
      return pathParts[productsIndex + 1];
    }
    return null;
  }
  _cacheEls() {
    this.currentPriceEl = this.querySelector('.current-price');
    this.compareAtEl = this.querySelector('.compare-at-price');
    this.badgeEl = this.querySelector('.new-price-badge');
    this.installmentEl = this.querySelector('.installment-price');
    this.countdownLabelEl = this.querySelector('.countdown-label');
    this.countdownTimerEl = this.querySelector('.countdown-timer');
    this.countdownContainerEl = this.querySelector('.offer-countdown');
  }
  beginCountdown(options = {}) {
    if (!this.countdownTimerEl) return;
    
    // 获取倒计时分钟数和标签
    const minutes = typeof options.minutes === 'number' ? options.minutes : (parseInt(this._countdownMinutes) || 0);
    const label = options.label != null ? String(options.label) : (this._countdownLabel || '');
    
    // 设置标签文本
    if (this.countdownLabelEl && label) {
      this.countdownLabelEl.textContent = label;
    }
    
    // 如果分钟数无效，显示 00:00:00
    if (!minutes || minutes <= 0) {
      this.countdownTimerEl.textContent = '00 : 00 : 00';
      return;
    }
    
    // 清除旧的倒计时
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
    
    // 计算结束时间
    this._countdownEndTime = Date.now() + minutes * 60 * 1000;
    
    // 补零函数
    const pad = (n) => String(n).padStart(2, '0');
    
    // 更新倒计时显示
    const updateCountdown = () => {
      const remainMs = Math.max(0, this._countdownEndTime - Date.now());
      const totalSec = Math.floor(remainMs / 1000);
      
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;
      
      this.countdownTimerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
      
      // 如果倒计时未结束，继续下一帧
      if (remainMs > 0) {
        this._countdownRAF = requestAnimationFrame(updateCountdown);
      } else {
        this._countdownRAF = null;
        // 倒计时结束，隐藏倒计时容器
        if (this.countdownContainerEl) {
          this.countdownContainerEl.classList.add('hidden');
        }
      }
    };
    
    // 立即执行一次并开始循环
    updateCountdown();
  }

  _onGlobalBeginCountdown(e) {
    const detail = (e && e.detail) || {};
    const sectionId = this.getAttribute('data-section-id');
    if (!detail.sectionId || detail.sectionId === sectionId) {
      this.countdownContainerEl.classList.remove('hidden');
      this.beginCountdown(detail);
    }
  }
  _onScroll() {
    if (this._modalCalled || !this.currentPriceEl) return;
    const rect = this.currentPriceEl.getBoundingClientRect();
    const centerY = window.innerHeight / 2;
    const centerVisible = rect.top - 100 <= centerY;
    if(this._hasTriggeredModal === 0) { // 因为centerVisible值不稳定，所以不能&&一起判断
      if (centerVisible) {
        this._modalCalled = true;
        try { this.triggerModal(); } catch (e) {}
      }
    } else {
      this._switchToFinal();
    }
  }
  _switchToFinal() {
    if (!this.currentPriceEl) return;
    const fromCurrent = this._getDisplayedNumber(this.currentPriceEl);
    if (this._price != null) {
      this._animateMoney(this.currentPriceEl, fromCurrent, this._price, { suffix: ' €' });
    }
    if (this.compareAtEl) {
      this.compareAtEl.classList.remove('hidden');
    }
    if (this.badgeEl) {
      const badgeFrom = this._extractNumberFromText(this.badgeEl.textContent);
      this.badgeEl.style.marginTop = '0px';
      this._animateMoney(this.badgeEl, badgeFrom, this._savings, { suffix: ' € RABATT', decimals: 0 });
    }
    if (this.installmentEl) {
      const fromInstallment = this._getDisplayedNumber(this.installmentEl);
      const targetInstallment = (this._installments > 0 && this._price != null)
        ? Math.round((this._price * 100) / this._installments) / 100
        : (this._price != null ? this._price : fromInstallment);
      const hasMo = /\/mo\b/.test(this.installmentEl.textContent);
      this._animateMoney(this.installmentEl, fromInstallment, targetInstallment, { prefix: hasMo ? '/Monat' : '', suffix: ' €' });
    }
  }
  _safeParseMoney(val) {
    if (val == null || val === '' || val === 'null' || val === 'undefined') return null;
    const num = parseFloat(val);
    if (isNaN(num)) return null;
    return num / 100;
  }
  _getDisplayedNumber(el) {
    const text = (el && el.textContent ? el.textContent : '').replace(/[^\d.,-]/g, '');
    // Handle German format: replace periods/spaces (thousands separator) and convert comma to dot (decimal separator)
    const normalized = text.replace(/[.\s]/g, '').replace(/,/g, '.');
    const n = parseFloat(normalized);
    return isNaN(n) ? 0 : n;
  }
  _extractNumberFromText(text) {
    if (!text) return 0;
    const t = String(text).replace(/[^\d.,-]/g, '');
    // Handle German format: replace periods/spaces (thousands separator) and convert comma to dot (decimal separator)
    const normalized = t.replace(/[.\s]/g, '').replace(/,/g, '.');
    const n = parseFloat(normalized);
    return isNaN(n) ? 0 : n;
  }
  _formatMoney(val, decimals = 2) {
    const n = typeof val === 'number' ? val : parseFloat(val) || 0;
    // Use German locale for formatting: 329,00 instead of 329.00
    return n.toLocaleString('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  _animateMoney(el, from, to, opts = {}) {
    const prefix = opts.prefix || '';
    const suffix = opts.suffix || '';
    const decimals = Number.isInteger(opts.decimals) ? opts.decimals : 2;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      el.textContent = prefix + this._formatMoney(to, decimals) + suffix;
      return;
    }
    const start = performance.now();
    const duration = 700;
    const animate = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const val = from + (to - from) * p;
      // Prevent negative values from being displayed during animation
      const displayVal = Math.max(0, val);
      el.textContent = prefix + this._formatMoney(displayVal, decimals) + suffix;
      if (p < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }
}

if (!window.customElements.get('ofp-price')) {
  customElements.define('ofp-price', OfpPrice);
}

// 顶部固定锚点条 - 单个锚点项
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorItem extends HTMLElement {
  constructor() {
    super();
    this.selectorStr = this.getAttribute("selector-str");
    this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1;
    this.rewriteId = this.getAttribute("rewrite-id");
    this.headerAnchorContainer = this.closest('header-anchor-container');
    this.targetDom = null; // 目标dom元素
    this.targetDomIdAttr = ""; // 目标dom元素的id值
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.targetDom = this.getTargetDom();
    if (!this.targetDom) {
      return;
    }
    
    if (this.rewriteId) {
      this.rewriteDomId();
    }
    
    // 获取并存储目标DOM的id属性值
    this.targetDomIdAttr = this.targetDom.getAttribute("id") || "";
    
    this.rewriteAEle();
    this.setupClickListener();
  }

  getTargetDom() {
    try {
      if (this.nthDom - 1 < 0) return null;
      
      // 分两步处理：先查询所有元素，再获取指定索引的元素
      const allElements = document.querySelectorAll(`${this.selectorStr}`);
      if (!allElements || allElements.length === 0) return null;
      
      const targetDom = allElements[this.nthDom - 1];
      return targetDom || null;
    } catch (error) {
      console.error('Error in getTargetDom:', error);
      return null;
    }
  }

  rewriteDomId() {
    this.targetDom.setAttribute('id', this.rewriteId);
  }

  rewriteAEle() {
    const aEle = this.querySelector("a");
    const targetDomId = this.targetDom.getAttribute("id");
    if (!aEle || !targetDomId) {
      return;
    }
    aEle.setAttribute("href", `#${targetDomId}`);
  }

  setupClickListener() {
    const aEle = this.querySelector("a");
    if (!aEle) return;

    aEle.addEventListener('click', (e) => {
      // 移除所有锚点的激活态
      if (this.headerAnchorContainer) {
        const allLinks = this.headerAnchorContainer.querySelectorAll('.header-anchor-item');
        allLinks.forEach(link => link.classList.remove('active'));
      }
      if (this.targetDomIdAttr) { //目标dom元素必须要有id，我才给它激活态
        // 为当前点击的锚点添加激活态
        this.classList.add('active');
      }
    });
  }
}

if (!window.customElements.get("header-anchor-item")) {
  customElements.define("header-anchor-item", HeaderAnchorItem);
}

// 顶部固定锚点条 - 容器（负责滚动追踪和固定定位）
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorContainer extends HTMLElement {
  constructor() {
    super();
    this.hadFixedTopClassArr = this.getAttribute("had-fixed-top-class-arr");
    this.dynamicFixedTopSelectorArr = this.getAttribute("dynamic-fixed-top-selector-arr");
    this.observer = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.setupScrollTracking();
    this.setFixedTopPosition();
    this.setupDynamicElementObserver();
  }
  
  /* 监听动态插件元素的出现，并重新计算top值 */
  setupDynamicElementObserver() {
    if (!this.dynamicFixedTopSelectorArr) return;
    
    const selectorArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
    if (selectorArr.length === 0) return;
    
    // 使用MutationObserver监听DOM变化
    this.observer = new MutationObserver(() => {
      // 检查是否有配置的动态元素出现
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      
      if (hasDynamicElements) {
        // 重新计算top值
        this.setFixedTopPosition();
      }
    });
    
    // 开始观察整个document的子树变化
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // 初始检查一次
    setTimeout(() => {
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      if (hasDynamicElements) {
        this.setFixedTopPosition();
      }
    }, 500);
  }
  
  disconnectedCallback() {
    // 清理observer
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /* 设置滚动追踪(当滚动到某个section时，对应的锚点项会高亮) */
  setupScrollTracking() {
    const allItems = Array.from(this.querySelectorAll('header-anchor-item'));
    
    // 获取所有目标元素
    const targetElements = allItems.map(item => {
      try {
        const selectorStr = item.getAttribute("selector-str");
        const nthDom = parseInt(item.getAttribute("nth-dom")) || 1;
        const elements = document.querySelectorAll(selectorStr);
        return elements[nthDom - 1];
      } catch (error) {
        console.error('Error querying selector in setupScrollTracking:', error);
        return null;
      }
    }).filter(Boolean);

    const calculateActive = () => {
      const viewportHeight = window.innerHeight;
      // 屏幕底部上方30%的位置
      const triggerPoint = viewportHeight * 0.6; // 底部上方30% = 从顶部算70%
      
      let currentId = '';
      
      // 找到当前滚动位置对应的section
      // 从后往前遍历，找到第一个顶部位置在触发点之上的元素
      for (let i = targetElements.length - 1; i >= 0; i--) {
        const element = targetElements[i];
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top;
        
        // 如果元素顶部已经到达或超过触发点（在触发点上方）
        if (elementTop <= triggerPoint) {
          currentId = element.getAttribute('id');
          break;
        }
      }

      // 更新所有链接的active状态
      allItems.forEach((item) => {
        item.classList.remove('active');
        if (item.querySelector('a')?.getAttribute('href')?.substring(1) === currentId) {
          item.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', calculateActive);
    calculateActive();
  }

  setFixedTopPosition() {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) return;

    let topValue = 0;
    
    // 计算hadFixedTopClassArr的高度
    if (this.hadFixedTopClassArr) {
      const classArr = this.hadFixedTopClassArr.split(',').map(c => c.trim()).filter(Boolean);
      topValue += classArr.reduce((prev, item) => {
        let height = 0;
        const element = document.querySelector(item);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }
    
    // 计算dynamicFixedTopSelectorArr的高度
    if (this.dynamicFixedTopSelectorArr) {
      const dynamicArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
      topValue += dynamicArr.reduce((prev, selector) => {
        let height = 0;
        const element = document.querySelector(selector);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }

    section.style.top = topValue + 'px';
  }
}

if (!window.customElements.get("header-anchor-container")) {
  customElements.define("header-anchor-container", HeaderAnchorContainer);
}

// Custom: Tab Product Showcase Logic
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.updateIndicator = this.updateIndicator.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab-nav-item');
    this.panels = this.querySelectorAll('.tab-panel');
    this.indicator = this.querySelector('.tab-indicator');
    
    // Initialize indicator position
    const initialActive = this.querySelector('.tab-nav-item.active');
    if (initialActive) {
      // Use requestAnimationFrame and setTimeout to ensure accurate layout
      requestAnimationFrame(() => this.updateIndicator(initialActive));
      setTimeout(() => this.updateIndicator(initialActive), 100);
    }

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all
        this.tabs.forEach(t => t.classList.remove('active'));
        this.panels.forEach(p => p.classList.remove('active'));

        // Add active to clicked
        tab.classList.add('active');
        
        // Update indicator position
        this.updateIndicator(tab);

        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
            targetPanel.classList.add('active');
            // Trigger resize event to ensure scroll area recalculates if needed
            window.dispatchEvent(new Event('resize'));
        }
      });
    });

    // Handle resize
    window.addEventListener('resize', () => {
      const active = this.querySelector('.tab-nav-item.active');
      if (active) this.updateIndicator(active);
    });
  }

  updateIndicator(activeTab) {
    if (!activeTab || !this.indicator) return;
    this.indicator.style.width = `${activeTab.offsetWidth}px`;
    this.indicator.style.left = `${activeTab.offsetLeft}px`;
  }
}

if (!window.customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.from = 0; // 默认起始值
    this.currentValue = 0;
    this.hasAnimated = false; // 跟踪动画是否已经播放过
    this.observer = null;
    this.originalText = ''; // 存储原始文本以分析格式
    this.decimalPlaces = 0; // 存储小数位数
  }

  connectedCallback() {
    // 保存原始文本
    this.originalText = this.textContent.trim();
    
    // 获取目标值
    this.to = parseFloat(this.originalText);

    if (isNaN(this.to)) {
      return;
    }

    this.duration = parseFloat(this.getAttribute('duration')) || 1.0;
    
    // 设置起始值（从0开始或者目标值的一小部分）
    this.from = this.to > 100 ? this.to * 0.5 : 0;
    
    // 分析原始数字的小数位数
    this.analyzeDecimalPlaces();
    
    // 初始显示起始值
    this.updateNumber(this.from);
    
    // 使用 IntersectionObserver 监视元素是否进入视口
    this.setupIntersectionObserver();
  }

  // 分析原始数字的小数位数
  analyzeDecimalPlaces() {
    const parts = this.originalText.split('.');
    if (parts.length > 1) {
      this.decimalPlaces = parts[1].length;
    } else {
      this.decimalPlaces = 0;
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      
      // 当元素进入视口且动画尚未播放时开始动画
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          this.animateNumberChange(this.from, this.to);
          this.hasAnimated = true;
        }, 600);
      }
    }, {
      threshold: 0.1 // 当元素有10%进入视口时触发
    });
    
    this.observer.observe(this);
  }

  // 缓动函数 - 指数减速
  easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }

  // 更新显示的数字，保持与原始输入相同的小数位数
  updateNumber(value) {
    this.currentValue = value;
    // 使用分析出的小数位数格式化数字
    this.textContent = value.toFixed(this.decimalPlaces);
  }

  async animateNumberChange(from, to) {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      // 如果用户偏好减少动画，则直接显示最终结果而不进行动画
      this.updateNumber(to);
      return;
    }
    
    const duration = this.duration; // 动画持续时间，单位秒
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = (currentTime - startTime) / 1000; // 转换为秒
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = this.easeOutExpo(progress);
      const currentValue = from + (to - from) * easedProgress;
      
      this.updateNumber(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    // 清理观察器以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("animation-text")) {
  customElements.define("animation-text", AnimationText);
}


// 一级菜单激活时显示滑动红条（is="nav-active-bar-container"）
class NavActiveBarContainer extends HTMLElement {
  connectedCallback() {
    if (this._inited) return;
    this._inited = true;
    this.bar = this.querySelector(':scope > .nav-active-bar');
    if (!this.bar) return;
    this.items = Array.from(this.querySelectorAll(':scope > ul > li.first-level-li'));
    this.observers = [];
    this.items.forEach((li) => {
      const details = li.querySelector(':scope > details');
      if (details) {
        details.addEventListener('toggle', () => this.update());
      }
    });
    this._onResize = () => this.update();
    window.addEventListener('resize', this._onResize);
    requestAnimationFrame(() => this.update());
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  update() {
    if (!this.bar) return;
    const activeLi = this.items.find((li) => {
      const d = li.querySelector(':scope > details');
      return d && d.open;
    });
    if (!activeLi) {
      this.bar.classList.remove('is-active');
      return;
    }
    const target = activeLi.querySelector(':scope > details > summary') || activeLi;
    const containerRect = this.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const left = targetRect.left - containerRect.left;
    const width = targetRect.width;
    this.bar.style.transform = `translateX(${left}px)`;
    this.bar.style.width = `${width}px`;
    this.bar.classList.add('is-active');
  }
}
if (!window.customElements.get('nav-active-bar-container')) {
  customElements.define('nav-active-bar-container', NavActiveBarContainer, { extends: 'nav' });
}

class FeatureTabs extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
    this.pauseTimer = null;
    this.currentIndex = 0;
    this.isAutoScrolling = false; 
    this.observer = null;
  }

  connectedCallback() {
    // --- 需求3：如果配置为禁用，直接退出 ---
    if (this.dataset.disableJs === 'true') {
      return; 
    }

    this.textItems = this.querySelectorAll(".ft-content-item");
    this.mediaItems = this.querySelectorAll(".ft-media-item");
    this.contentCol = this.querySelector(".ft-content-col");
    this.mobileIndicators = this.querySelectorAll(".ft-indicator-dot");
    
    this.duration = (parseInt(this.dataset.duration) || 5) * 1000;

    // PC 点击交互
    this.textItems.forEach((textItem, index) => {
      textItem.addEventListener("click", () => {
        if (window.innerWidth > 768) {
          this.manualSwitch(index);
        }
      });
    });

    // H5 滚动监听
    if (window.innerWidth <= 768) {
      this.initMobileScrollObserver();
      this.initMobileTouchHandling();
    }

    // 初始化启动
    this.activateItem(0);
  }

  disconnectedCallback() {
    this.stopAutoPlay();
    if (this.pauseTimer) clearTimeout(this.pauseTimer);
    if (this.observer) this.observer.disconnect();
  }

  // --- 核心逻辑：切换激活项 ---
  activateItem(index) {
    this.currentIndex = index;

    // 1. 重置所有样式
    this.resetAllStyles();

    // 2. 激活图片
    this.mediaItems.forEach(img => img.classList.remove('active'));
    if(this.mediaItems[index]) this.mediaItems[index].classList.add("active");

    // 3. 激活文字块
    this.textItems.forEach(item => item.classList.remove('active'));
    this.textItems[index].classList.add("active");

    // 4. 动画处理
    if (window.innerWidth > 768) {
      this.runPcAnimation(index);
    } else {
      // 只有非用户交互产生的切换，才自动滚动
      if (!this.isUserInteracting) {
        this.isAutoScrolling = true;
        this.textItems[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setTimeout(() => { this.isAutoScrolling = false; }, 500);
      }
      this.runMobileAnimation(index);
    }

    // 5. 设置下一个自动轮播
    this.stopAutoPlay();
    this.timer = setTimeout(() => {
      const nextIndex = (index + 1) % this.textItems.length;
      this.activateItem(nextIndex);
    }, this.duration);
  }

  resetAllStyles() {
    this.querySelectorAll('.ft-progress-fill-vertical').forEach(el => {
      el.style.transition = 'none';
      el.style.height = '0%';
    });
    this.mobileIndicators.forEach(dot => {
      dot.classList.remove('active');
      const fill = dot.querySelector('.ft-indicator-fill');
      fill.style.transition = 'none';
      fill.style.width = '0%';
    });
  }

  runPcAnimation(index) {
    const bar = this.textItems[index].querySelector(".ft-progress-fill-vertical");
    if(bar) {
        void bar.offsetWidth; 
        bar.style.transition = `height ${this.duration}ms linear`;
        bar.style.height = "100%";
    }
  }

  runMobileAnimation(index) {
    const dot = this.mobileIndicators[index];
    if (dot) {
      dot.classList.add('active'); 
      const fill = dot.querySelector('.ft-indicator-fill');
      void fill.offsetWidth; 
      fill.style.transition = `width ${this.duration}ms linear`;
      fill.style.width = "100%";
    }
  }

  manualSwitch(index) {
    this.stopAutoPlay();
    this.activateItem(index);
  }

  stopAutoPlay() {
    if (this.timer) clearTimeout(this.timer);
  }

  // ==========================================
  // H5 专属功能
  // ==========================================

  initMobileScrollObserver() {
    const options = {
      root: this.contentCol,
      threshold: 0.5 
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const newIndex = parseInt(entry.target.dataset.index);
          
          if (!this.isAutoScrolling && newIndex !== this.currentIndex) {
            this.currentIndex = newIndex;
            
            // 切换图片
            this.mediaItems.forEach(img => img.classList.remove('active'));
            if(this.mediaItems[newIndex]) this.mediaItems[newIndex].classList.add("active");

            // 切换文字激活状态
            this.textItems.forEach(item => item.classList.remove('active'));
            if(this.textItems[newIndex]) this.textItems[newIndex].classList.add('active');

            // 切换底部圆点状态
            this.resetAllStyles(); 
            this.mobileIndicators.forEach(d => d.classList.remove('active'));
            if(this.mobileIndicators[newIndex]) this.mobileIndicators[newIndex].classList.add('active');
          }
        }
      });
    }, options);

    this.textItems.forEach(item => this.observer.observe(item));
  }

  initMobileTouchHandling() {
    this.isUserInteracting = false;

    this.contentCol.addEventListener('touchstart', () => {
      this.isUserInteracting = true;
      this.stopAutoPlay(); 
      if (this.pauseTimer) clearTimeout(this.pauseTimer); 
      
      this.resetAllStyles();
      if(this.mobileIndicators[this.currentIndex]) {
          this.mobileIndicators[this.currentIndex].classList.add('active');
      }
    }, { passive: true });

    this.contentCol.addEventListener('touchend', () => {
      this.isUserInteracting = false;
      if (this.pauseTimer) clearTimeout(this.pauseTimer);
      
      this.pauseTimer = setTimeout(() => {
        this.activateItem(this.currentIndex);
      }, 2200);
    });
  }
}

if (!window.customElements.get("feature-tabs")) {
  customElements.define("feature-tabs", FeatureTabs);
}

class CountdownTimer2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.deadlineStr = this.getAttribute('data-deadline');
    this.elements = {
      days: this.querySelector('[data-type="days"]'),
      hours: this.querySelector('[data-type="hours"]'),
      minutes: this.querySelector('[data-type="minutes"]'),
      seconds: this.querySelector('[data-type="seconds"]')
    };

    if (!this.deadlineStr) return;

    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateTimer() {
    // 兼容性处理：将 '-' 替换为 '/' 以支持 Safari
    const formattedDate = this.deadlineStr.replace(/-/g, '/'); 
    const deadline = new Date(formattedDate).getTime();
    const now = new Date().getTime();
    const diff = deadline - now;

    if (diff <= 0) {
      clearInterval(this.timerInterval);
      this.render(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.render(days, hours, minutes, seconds);
  }

  render(d, h, m, s) {
    if(this.elements.days) this.elements.days.textContent = this.pad(d);
    if(this.elements.hours) this.elements.hours.textContent = this.pad(h);
    if(this.elements.minutes) this.elements.minutes.textContent = this.pad(m);
    if(this.elements.seconds) this.elements.seconds.textContent = this.pad(s);
  }

  pad(num) {
    return num < 10 ? '0' + num : num;
  }
}

if (!window.customElements.get('countdown-timer2')) {
  customElements.define('countdown-timer2', CountdownTimer2);
}

/**
 * Class: CouponCopier
 * 功能: 处理点击复制按钮逻辑
 */
class CouponCopier extends HTMLElement {
  constructor() {
    super();
    this.handleCopy = this.handleCopy.bind(this);
  }

  connectedCallback() {
    this.codeToCopy = this.getAttribute('data-code');
    this.button = this.querySelector('button');
    
    if (this.button) {
      // 保存原始按钮文案 (Copy)，以便还原
      this.originalText = this.button.textContent;
      this.button.addEventListener('click', this.handleCopy);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleCopy);
    }
  }

  handleCopy() {
    if (!navigator.clipboard || !this.codeToCopy) {
      console.warn('Clipboard API not available or no code provided');
      return;
    }

    navigator.clipboard.writeText(this.codeToCopy)
      .then(() => {
        this.button.textContent = 'Kopiert';
        
        // 如果有之前的计时器，先清除，防止快速点击导致显示异常
        if (this.revertTimeout) {
          clearTimeout(this.revertTimeout);
        }

        this.revertTimeout = setTimeout(() => {
          this.button.textContent = this.originalText;
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
}

if (!window.customElements.get('coupon-copier')) {
  customElements.define('coupon-copier', CouponCopier);
}

class promoCard extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.js-add-to-cart');
    this.variantId = this.dataset.variantId;
    this.originalText = "In den Warenkorb";
    this.isAnimating = false;
    
    if(this.btn) {
      this.btn.addEventListener('click', this.addToCart.bind(this));
    }
  }

  addToCart() {
    if(this.isAnimating || !this.variantId) return;
    this.isAnimating = true;

    // Start Animation
    this.startAnimation();

    // Add to Cart Logic
    let formData = {
      'items': [{
        'id': this.variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event); // 触发事件
      if(!document.body.classList.contains('smart-cart--enabled')) document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      setTimeout(() => {
        this.stopAnimation();
      }, 3000);
    });
  }

  startAnimation() {
    const span = this.btn.querySelector('.btn-text');
    let dots = 0;
    span.textContent = "In den Warenkorb";
    
    this.animationInterval = setInterval(() => {
      dots = (dots + 1) % 4; 
      let dotStr = "";
      for(let i=0; i<dots; i++) dotStr += ".";
      span.textContent = "In den Warenkorb" + dotStr;
    }, 500); 
  }

  stopAnimation() {
    clearInterval(this.animationInterval);
    const span = this.btn.querySelector('.btn-text');
    span.textContent = this.originalText;
    this.isAnimating = false;
  }
}

if (!window.customElements.get('custom-element-promo-card')) {
  customElements.define('custom-element-promo-card', promoCard);
}

// Feature Accordion 风琴组+图片组件
class FeatureAccordion extends HTMLElement {
  constructor() {
    super();
    this.allowMultiple = this.dataset.allowMultiple === 'true';

    // Elements
    this.items = this.querySelectorAll('.fa-item');
    this.desktopImages = this.querySelectorAll('.fa-desktop-image-item');

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const header = item.querySelector('.fa-item-header');

      // Click Event
      header.addEventListener('click', () => {
        this.toggleItem(index);
      });
    });

    // 从 data-default-open 属性读取默认打开的项目
    this.items.forEach((item, index) => {
      if (item.dataset.defaultOpen === 'true') {
        this.openItem(index);
      }
    });
  }

  toggleItem(index) {
    const item = this.items[index];
    const isOpen = item.classList.contains('open');

    if (!this.allowMultiple) {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.closeAll();
        this.openItem(index);
      }
    } else {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.openItem(index);
      }
    }
  }

  openItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.add('open');

    if(this.desktopImages[index]) {
      this.desktopImages.forEach(img => img.classList.remove('active'));
      this.desktopImages[index].classList.add('active');
    }
  }

  closeItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.remove('open');

    if(this.desktopImages[index]) {
      this.desktopImages[index].classList.remove('active');
    }
  }

  closeAll() {
    this.items.forEach((el, i) => {
      this.closeItem(i);
    });
  }
}

if (!window.customElements.get('feature-accordion')) {
  customElements.define('feature-accordion', FeatureAccordion);
}

class ProductFilterSection extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.config = {};
    this.activeFilters = {}; 
  }

  connectedCallback() {
    // 1. 初始化数据
    try {
      const dataScript = this.querySelector('#product-data-pool');
      const configScript = this.querySelector('#config-data');
      if (dataScript) this.products = JSON.parse(dataScript.textContent);
      if (configScript) this.config = JSON.parse(configScript.textContent);

      // 解析优先展示标签配置
      this.priorityTags = [];
      if (this.config.priority_tags) {
        this.priorityTags = this.config.priority_tags.split(',').map(t => t.trim()).filter(Boolean);
      }
      
      // 数据预处理（variant级别）
      // filter_show: 分号分隔，既用于筛选也用于显示
      // filter_hide: 分号分隔，只用于筛选不显示
      this.products = this.products.map(v => {
          // 解析filter_show（显示+筛选）
          let showTags = [];
          if (v.filter_show) {
              v.filter_show.split(';').forEach(t => {
                  const trimmed = t.trim();
                  if (trimmed) showTags.push(trimmed);
              });
          }

          // 解析filter_hide（仅筛选）
          let hideTags = [];
          if (v.filter_hide) {
              v.filter_hide.split(';').forEach(t => {
                  const trimmed = t.trim();
                  if (trimmed) hideTags.push(trimmed);
              });
          }

          // display_tags: 只包含filter_show的标签
          v.display_tags = [...new Set(showTags)];
          // filter_tags: 包含filter_show和filter_hide的所有标签
          v.filter_tags = [...new Set([...showTags, ...hideTags])];

          v.quote = v.quote || "";
          return v;
      });

    } catch (e) {
      console.error('Error parsing product data:', e);
    }

    this.resultsContainer = this.querySelector('[id^="filter-results-"]');
    this.initEventListeners();
    
    // 2. 检查 URL 参数
    this.checkUrlParams();
  }

  checkUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const filtersParam = params.get('filters');

    if (filtersParam) {
      // --- 现有逻辑：如果有 URL 参数 ---
      const tagsToSelect = filtersParam.split(',').map(tag => decodeURIComponent(tag.trim()));
      const allButtons = this.querySelectorAll('.filter-btn');
      let hasChanges = false;

      allButtons.forEach(btn => {
        const btnValue = btn.dataset.value;
        const groupDiv = btn.closest('.tag-group');
        const groupId = groupDiv.dataset.groupId;

        if (tagsToSelect.includes(btnValue)) {
          // 清除同组其他高亮
          groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
          // 激活当前
          btn.classList.add('active');
          this.activeFilters[groupId] = btnValue;
          hasChanges = true;
        }
      });

      if (hasChanges) {
        this.filterAndSortProducts();
      } else {
        // 如果参数有误没匹配到任何按钮，展示默认前6个（无筛选项时显示6个）
        this.renderProducts(this.products.slice(0, 6));
      }
    } else {
      const defaultTagsRaw = this.dataset.defaultTags || this.getAttribute('data-default-tags') || '';
      const defaultTags = defaultTagsRaw
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);

      const escapeCssValue = (value) => {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(value);
        }
        return String(value).replace(/[^a-zA-Z0-9_\u00A0-\uFFFF-]/g, (ch) => `\\${ch}`);
      };

      defaultTags.forEach((defaultTag) => {
        const defaultBtn = this.querySelector(`.filter-btn[data-value="${escapeCssValue(defaultTag)}"]`);

        if (!defaultBtn) return;

        const groupDiv = defaultBtn.closest('.tag-group');
        if (!groupDiv) return;

        const groupId = groupDiv.dataset.groupId;

        // 同组只允许一个选中：清除同组其他
        groupDiv.querySelectorAll('.filter-btn').forEach(b => {
          b.classList.remove('active');
        });

        defaultBtn.classList.add('active');
        this.activeFilters[groupId] = defaultTag;
      });

      // 无论是否匹配到按钮，都走统一的渲染逻辑
      // - 匹配到了：会按默认选中标签进行筛选
      // - 没匹配到/没配置：展示默认结果
      this.filterAndSortProducts();
    }
  }

  initEventListeners() {
    const buttons = this.querySelectorAll('.filter-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.handleFilterClick(e.currentTarget);
      });
    });
  }

  handleFilterClick(clickedBtn) {
    const groupDiv = clickedBtn.closest('.tag-group');
    const groupId = groupDiv.dataset.groupId;
    const value = clickedBtn.dataset.value;
    const isAlreadyActive = clickedBtn.classList.contains('active');
    
    groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));

    if (isAlreadyActive) {
      delete this.activeFilters[groupId];
    } else {
      clickedBtn.classList.add('active');
      this.activeFilters[groupId] = value;
    }

    this.filterAndSortProducts();
  }

  /**
   * 获取组合的辅助函数
   * 逻辑说明：标准的递归回溯。
   * 对于数组 [A, B, C]，取 k=2：
   * 1. 优先取前面的 -> [A, B] (相当于剔除了最后一个 C)
   * 2. 然后取 -> [A, C] (相当于剔除了倒数第二个 B)
   * 3. 最后取 -> [B, C] (相当于剔除了第一个 A)
   * 这个生成顺序完美符合需求中“先剔除最后一个，再剔除倒数第二个”的逻辑。
   */
  getCombinations(arr, k) {
    const results = [];
    function backtrack(start, combo) {
      if (combo.length === k) {
        results.push([...combo]);
        return;
      }
      for (let i = start; i < arr.length; i++) {
        combo.push(arr[i]);
        backtrack(i + 1, combo);
        combo.pop();
      }
    }
    backtrack(0, []);
    return results;
  }

  /**
   * 计算某产品在特定标签组合下的得分（用于同级排序）
   * @param {Object} product - 产品对象
   * @param {Array} tags - 当前匹配的标签数组
   * @returns {Number} - display_tags 命中的数量
   */
  calculateDisplayScore(product, tags) {
    let score = 0;
    tags.forEach(tag => {
      if (product.display_tags.includes(tag)) {
        score++;
      }
    });
    return score;
  }

  /**
   * 检查产品是否匹配了任何优先展示标签
   * @param {Object} product - 产品对象
   * @param {Array} selectedTags - 当前选中的标签数组
   * @returns {Boolean} - 是否匹配优先展示标签
   */
  hasPriorityTag(product, selectedTags) {
    // 检查选中的标签中是否有优先展示标签，且产品匹配了该标签
    return selectedTags.some(tag =>
      this.priorityTags.includes(tag) && product.filter_tags.includes(tag)
    );
  }

  /**
   * 核心筛选与排序算法（variant级别）
   * 优化点：在每一层匹配数量(k)的循环中，引入“层级候选池”。
   * 先收集该层级所有匹配的变体，然后根据显性标签(display_tags)的权重进行排序，
   * 确保：同为命中1个标签时，命中显性标签的变体排在命中隐性标签的变体前面。
   */
  filterAndSortProducts() {
    // 一、设置变量
    const maxResults = 6;
    const selectedTags = Object.values(this.activeFilters).sort();
    let finalResults = [];
    let seenVariantIds = new Set(); // 全局去重，防止同一个变体被多次添加

    // 二、多标签筛选逻辑 (瀑布流)
    if (selectedTags.length > 0) {

      // 循环 k：从匹配所有选中标签 (n) 开始，递减到 1
      for (let k = selectedTags.length; k >= 1; k--) {
        
        // --- 核心修改开始：创建当前层级的临时候选池 ---
        let layerCandidates = [];
        let layerSeenIds = new Set(); // 当前层级去重，防止同一变体在不同组合中重复出现

        // 1. 获取选中的 n 个标签中，取 k 个的所有组合
        const combinations = this.getCombinations(selectedTags, k);

        // 2. 遍历每一个组合
        for (const comboTags of combinations) {
          
          // 3. 在变体池中查找匹配当前组合的变体
          for (const variant of this.products) {
            // 如果已经在最终结果里了，跳过
            if (seenVariantIds.has(variant.id)) continue; 
            // 如果已经在当前层级的候选池里了，也跳过
            if (layerSeenIds.has(variant.id)) continue;

            // 严格匹配：变体必须包含当前组合内的所有标签
            const isMatch = comboTags.every(tag => variant.filter_tags.includes(tag));

            if (isMatch) {
              layerCandidates.push(variant);
              layerSeenIds.add(variant.id);
            }
          }
        }

        // 4. 【关键优化】在层级循环结束、加入最终结果之前，对 layerCandidates 进行排序
        // 逻辑：在匹配数量相同(k)的情况下，谁包含的“显性标签(display_tags)”更多，谁排前面。
        if (layerCandidates.length > 0) {
          layerCandidates.sort((a, b) => {
            // 注意：这里传入 selectedTags 而不是 comboTags
            // 我们要看在用户选中的所有标签里，变体命中了多少个显性标签
            const scoreA = this.calculateDisplayScore(a, selectedTags);
            const scoreB = this.calculateDisplayScore(b, selectedTags);
            return scoreB - scoreA; // 降序排列
          });

          // 5. 将排序后的当前层级结果加入最终结果
          for (const candidate of layerCandidates) {
            // 双重保险检查，虽然上面逻辑已经保证了唯一性
            if (!seenVariantIds.has(candidate.id)) {
              finalResults.push(candidate);
              seenVariantIds.add(candidate.id);
            }
          }
        }
        // --- 核心修改结束 ---
      }
    }

    // 三、兜底/补充逻辑 (保持不变)
    // 只有没有选中任何筛选项时，才补全到6个 (或者你可以根据需求决定是否在筛选结果不足6个时补全)
    // 这里的逻辑维持你原本的意图：仅当没有 activeFilters 时才补全，或者筛选结果太少时补全？
    // 根据你之前的代码逻辑，是 "如果没选中任何筛选项...才补全"。
    // 如果想要"筛选结果不足6个时也补全"，可以去掉 !hasActiveFilters 的判断，只保留 length 判断。
    // 这里保持你原有的逻辑：
    const hasActiveFilters = selectedTags.length > 0;

    if (!hasActiveFilters && finalResults.length < maxResults) {
      for (const variant of this.products) {
        if (finalResults.length >= maxResults) break;
        if (seenVariantIds.has(variant.id)) continue;
        if (variant.filter_tags && variant.filter_tags.length > 0) {
          finalResults.push(variant);
          seenVariantIds.add(variant.id);
        }
      }
    }

    // 四、优先展示排序 (全局优先，保持不变)
    if (selectedTags.length > 0 && this.priorityTags.length > 0) {
      finalResults.sort((a, b) => {
        const aPriority = this.hasPriorityTag(a, selectedTags) ? 1 : 0;
        const bPriority = this.hasPriorityTag(b, selectedTags) ? 1 : 0;
        return bPriority - aPriority; 
      });
    }

    // 五、截取前 maxResults 个结果
    if (finalResults.length > maxResults) {
      finalResults = finalResults.slice(0, maxResults);
    }

    // 六、渲染结果
    this.renderProducts(finalResults);
  }

  renderProducts(variantsToRender) {
    if (!variantsToRender.length) {
      this.resultsContainer.innerHTML = `<div class="no-results">${this.config.empty_text}</div>`;
      return;
    }

    const html = variantsToRender.map((variant, index) => {
      let badgeHtml = '';
      if (index === 0 && this.config.top1_icon && this.config.top1_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top1_icon}" class="rank-badge" alt="Top 1">`;
      } else if (index === 1 && this.config.top2_icon && this.config.top2_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top2_icon}" class="rank-badge" alt="Top 2">`;
      } else if (index === 2 && this.config.top3_icon && this.config.top3_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top3_icon}" class="rank-badge" alt="Top 3">`;
      }

      const tagsHtml = variant.display_tags.map(tag =>
        `<span class="display-tag">${tag}</span>`
      ).join('');

      const comparePriceHtml = variant.compare_price
        ? `<span class="compare-price">${variant.compare_price}</span>`
        : '';

      const quoteHtml = variant.quote
          ? `<div class="card-quote three-rows">"${variant.quote}"</div>`
          : '';

      return `
        <a href="${variant.url}" class="product-card">
          ${badgeHtml}
          <div class="card-image-wrapper">
            <img src="${variant.image}" loading="lazy" class="card-image" alt="${variant.product_title}">
          </div>
          <div class="card-info">
            <div class="card-title-wrapper">
              <h3 class="card-title">${variant.product_title}</h3>
              <div class="card-tags">
                ${tagsHtml}
              </div>
              ${quoteHtml}
            </div>
            <div class="card-price-row">
              <div class="price-wrapper">
                <span class="current-price">${variant.price}</span>
                ${comparePriceHtml}
              </div>
              <button class="view-btn">Details ansehen ></button>
            </div>
          </div>
        </a>
      `;
    }).join('');

    this.resultsContainer.innerHTML = html;
  }
}

if (!window.customElements.get('product-filter-section')) {
  customElements.define('product-filter-section', ProductFilterSection);
}

class TagRowV2 extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.tag-row-container');
    this.indicator = this.querySelector('.scroll-indicator');
    this.isOneRow = this.getAttribute('data-one-row') === 'true';

    this.supportsMouseDrag = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches);
    this.isHovered = false;
    this.isPointerDown = false;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;

    this.boundHandleScroll = this.handleScroll.bind(this);
    this.boundHandleMouseEnter = this.handleMouseEnter.bind(this);
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);
    this.boundHandleMouseDown = this.handleMouseDown.bind(this);
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);
    this.boundHandleMouseUp = this.handleMouseUp.bind(this);
    this.boundHandleClickCapture = this.handleClickCapture.bind(this);
    this.boundHandleIndicatorClick = this.handleIndicatorClick.bind(this);
  }

  connectedCallback() {
    if (this.isOneRow && this.container) {
      // 初始化检查是否溢出
      this.checkOverflow();
      
      // 监听窗口大小变化重新检查
      window.addEventListener('resize', this.boundCheckOverflow);
      
      // 监听滚动事件
      this.container.addEventListener('scroll', this.boundHandleScroll, { passive: true });

      if (this.indicator) {
        this.indicator.addEventListener('click', this.boundHandleIndicatorClick);
      }

      // PC 端：鼠标悬停出现抓手，并支持按住拖动横向滚动
      if (this.supportsMouseDrag) {
        this.container.addEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.addEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.addEventListener('mousedown', this.boundHandleMouseDown);
        // 捕获阶段拦截：拖动过就不触发 a 链接跳转
        this.container.addEventListener('click', this.boundHandleClickCapture, true);
      }
    }
  }

  disconnectedCallback() {
    if (this.isOneRow) {
      window.removeEventListener('resize', this.boundCheckOverflow);
    }

    if (this.container) {
      this.container.removeEventListener('scroll', this.boundHandleScroll);
      if (this.supportsMouseDrag) {
        this.container.removeEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.removeEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.removeEventListener('mousedown', this.boundHandleMouseDown);
        this.container.removeEventListener('click', this.boundHandleClickCapture, true);
      }
    }

    if (this.indicator) {
      this.indicator.removeEventListener('click', this.boundHandleIndicatorClick);
    }

    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);
  }

  // 绑定 resize 上下文
  boundCheckOverflow = () => {
    this.checkOverflow();
  }

  checkOverflow() {
    if (!this.container) return;
    if (!this.indicator) return;

    // scrollWidth > clientWidth 说明内容溢出
    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;

    if (this.supportsMouseDrag && this.isHovered && !this.isPointerDown) {
      this.container.style.cursor = isOverflowing ? 'grab' : '';
    }
    
    // 只有当溢出且用户还没滚动过(indicator没有被标记为scrolled)时显示
    if (isOverflowing && !this.indicator.classList.contains('has-scrolled')) {
      this.indicator.classList.remove('hidden');
    } else {
      this.indicator.classList.add('hidden');
    }
  }

  handleScroll() {
    if (!this.indicator) return;

    // 用户一旦滑动一下，该指示就消失，不再出现
    // 添加一个 has-scrolled 标记，防止 resize 再次触发显示
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleIndicatorClick(e) {
    if (!this.indicator) return;
    e.preventDefault();
    e.stopPropagation();
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleMouseEnter() {
    this.isHovered = true;
    this.checkOverflow();
  }

  handleMouseLeave() {
    this.isHovered = false;
    if (!this.isPointerDown && this.container) {
      this.container.style.cursor = '';
    }
  }

  handleMouseDown(e) {
    if (!this.container) return;
    if (e.button !== 0) return;

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    if (!isOverflowing) return;

    this.isPointerDown = true;
    this.isDragging = false;
    this.dragStartX = e.pageX;
    this.dragStartScrollLeft = this.container.scrollLeft;

    this.container.style.cursor = 'grabbing';
    this.container.style.userSelect = 'none';

    document.addEventListener('mousemove', this.boundHandleMouseMove);
    document.addEventListener('mouseup', this.boundHandleMouseUp);

    e.preventDefault();
  }

  handleMouseMove(e) {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    const dx = e.pageX - this.dragStartX;
    if (Math.abs(dx) > 3) this.isDragging = true;
    this.container.scrollLeft = this.dragStartScrollLeft - dx;

    if (this.isDragging) e.preventDefault();
  }

  handleMouseUp() {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    this.isPointerDown = false;
    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);

    this.container.style.userSelect = '';

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    this.container.style.cursor = (this.isHovered && isOverflowing) ? 'grab' : '';
  }

  handleClickCapture(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    e.stopPropagation();
    this.isDragging = false;
  }
}

// 注册 Web Component
if (!window.customElements.get('tag-row-v2')) {
  customElements.define('tag-row-v2', TagRowV2);
}

// Custom: Order Support Chat Trigger
class OrderSupportChatTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);

    if (document.querySelector('body > #chat-widget-container')) {
      this.onWidgetReady();
    } else {
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.id === 'chat-widget-container') {
              this.observer.disconnect();
              this.observer = null;
              this.onWidgetReady();
              return;
            }
          }
        }
      });
      this.observer.observe(document.body, { childList: true });
    }
  }

  onWidgetReady() {
    this.classList.remove('hidden');
  }

  handleClick() {
    try {
      if (typeof LiveChatWidget !== 'undefined') {
        document.body.classList.add('livechat-open');
        requestAnimationFrame(() => {
          LiveChatWidget.call('maximize');
        });
      }
    } catch (error) {
      console.error('OrderSupportChatTrigger: failed to open LiveChat', error);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!window.customElements.get('order-support-chat-trigger')) {
  customElements.define('order-support-chat-trigger', OrderSupportChatTrigger);
}

//自定义：Slideshow锚点跳转按钮
class SlideshowAnchorButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    const targetSelector = this.getAttribute("data-target")
    if (!targetSelector) return
    const targetEl = document.querySelector(targetSelector)
    if (targetEl) {
      targetEl.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}

if (!window.customElements.get("slideshow-anchor-button")) {
  customElements.define("slideshow-anchor-button", SlideshowAnchorButton)
}

class PressTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.press-ticker__track');
    if (!this.track) return;

    this.allItems = Array.from(this.track.querySelectorAll('.press-ticker__item'));

    this.mqlMobile = window.matchMedia('(max-width: 749px)');
    this._handleMQ = this._applyMode.bind(this);
    this.mqlMobile.addEventListener
      ? this.mqlMobile.addEventListener('change', this._handleMQ)
      : this.mqlMobile.addListener(this._handleMQ);

    this._applyMode();
  }

  disconnectedCallback() {
    this._stopMobileTimer();
    if (this.mqlMobile) {
      this.mqlMobile.removeEventListener
        ? this.mqlMobile.removeEventListener('change', this._handleMQ)
        : this.mqlMobile.removeListener(this._handleMQ);
    }
  }

  _applyMode() {
    if (this.mqlMobile.matches) {
      this._setupMobile();
    } else {
      this._setupDesktop();
    }
  }

  _setupDesktop() {
    this._stopMobileTimer();
    // 显示全部（两份）用于无缝滚动，清掉内联样式残留
    this.allItems.forEach((el) => {
      el.style.display = '';
      this._resetInner(el);
    });
  }

  _setupMobile() {
    this.allItems.forEach((el) => {
      const pass = parseInt(el.dataset.pass || '1', 10);
      el.style.display = pass === 1 ? '' : 'none';
      el.classList.remove('is-selected');
      this._resetInner(el);
    });

    this.mobileItems = this.allItems.filter((el) => parseInt(el.dataset.pass || '1', 10) === 1);
    if (this.mobileItems.length === 0) return;

    this.currentIndex = 0;
    this.mobileItems[0].classList.add('is-selected');

    if (this.mobileItems.length < 2) return;
    if (this.dataset.enableCarousel !== 'true') return;

    const hold = parseFloat(this.dataset.flipHold || '3') * 1000;
    this._mobileTimer = setInterval(() => this._transitionNext(), hold);
  }

  _resetInner(item) {
    const logo = item.querySelector('.press-ticker__logo');
    const quote = item.querySelector('.press-ticker__quote');
    if (logo) {
      logo.style.opacity = '';
      logo.style.transition = '';
    }
    if (quote) {
      quote.style.opacity = '';
      quote.style.transform = '';
      quote.style.transition = '';
    }
  }

  /**
   * 切换：严格参考 press.liquid 中 PressCarousel._transitionTo
   *   1. 先并行淡出旧 slide 的 .press-ticker__logo 与 .press-ticker__quote（quote 伴随 translateY(-10px)）
   *   2. 切换 .is-selected 类
   *   3. 再并行淡入新 slide 的 .press-ticker__logo 与 .press-ticker__quote（quote 从 translateY(10px) 回到 0）
   */
  async _transitionNext() {
    const items = this.mobileItems;
    if (!items || items.length < 2) return;

    const fromItem = items[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % items.length;
    const toItem = items[nextIndex];

    const duration = 200; // 对齐 press.js 的 0.2s

    await this._animateOut(fromItem, duration);

    fromItem.classList.remove('is-selected');
    toItem.classList.add('is-selected');

    // 切换后把旧 slide 的内联样式重置，避免下次进入时状态残留
    this._resetInner(fromItem);

    await this._animateIn(toItem, duration);

    this.currentIndex = nextIndex;
  }

  _animateOut(item, duration) {
    return new Promise((resolve) => {
      const logo = item.querySelector('.press-ticker__logo');
      const quote = item.querySelector('.press-ticker__quote');

      if (logo) {
        logo.style.transition = 'opacity ' + duration + 'ms ease';
        logo.style.opacity = '0';
      }
      if (quote) {
        quote.style.transition = 'opacity ' + duration + 'ms ease, transform ' + duration + 'ms ease';
        quote.style.opacity = '0';
        quote.style.transform = 'translateY(-10px)';
      }

      setTimeout(resolve, duration);
    });
  }

  _animateIn(item, duration) {
    return new Promise((resolve) => {
      const logo = item.querySelector('.press-ticker__logo');
      const quote = item.querySelector('.press-ticker__quote');

      // 起始态（无过渡）
      if (logo) {
        logo.style.transition = 'none';
        logo.style.opacity = '0';
      }
      if (quote) {
        quote.style.transition = 'none';
        quote.style.opacity = '0';
        quote.style.transform = 'translateY(10px)';
      }

      // 下一帧开启过渡到终态
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (logo) {
            logo.style.transition = 'opacity ' + duration + 'ms ease';
            logo.style.opacity = '1';
          }
          if (quote) {
            quote.style.transition = 'opacity ' + duration + 'ms ease, transform ' + duration + 'ms ease';
            quote.style.opacity = '1';
            quote.style.transform = 'translateY(0)';
          }
          setTimeout(resolve, duration);
        });
      });
    });
  }

  _stopMobileTimer() {
    if (this._mobileTimer) {
      clearInterval(this._mobileTimer);
      this._mobileTimer = null;
    }
  }
}
if (!window.customElements.get('press-ticker')) {
  customElements.define('press-ticker', PressTicker);
}

// 自定义：Shop By Category - PC 3列网格 + H5 Swiper+Tab 联动
class ShopByCategory extends HTMLElement {
  constructor() {
    super();
    this._mqMobile = window.matchMedia('(max-width: 767px)');
    this._swiper = null;
    this._resizeHandler = null;
    this._onTabClick = this._onTabClick.bind(this);
    this._onMqChange = this._onMqChange.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.sbc__tab'));
    this.indicator = this.querySelector('.sbc__tab-indicator');
    this.swiperEl = this.querySelector('.sbc__swiper');

    // 绑定 tab 点击事件
    this.tabs.forEach((tab) => tab.addEventListener('click', this._onTabClick));

    if (this._mqMobile.matches) {
      this._initMobile();
    }

    // 监听视口变化
    if (typeof this._mqMobile.addEventListener === 'function') {
      this._mqMobile.addEventListener('change', this._onMqChange);
    } else if (typeof this._mqMobile.addListener === 'function') {
      this._mqMobile.addListener(this._onMqChange);
    }
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this._onTabClick));
    this._destroyMobile();
    if (typeof this._mqMobile.removeEventListener === 'function') {
      this._mqMobile.removeEventListener('change', this._onMqChange);
    } else if (typeof this._mqMobile.removeListener === 'function') {
      this._mqMobile.removeListener(this._onMqChange);
    }
  }

  _onMqChange(e) {
    if (e.matches) {
      this._initMobile();
    } else {
      this._destroyMobile();
    }
  }

  _initMobile() {
    if (this._swiper || !this.swiperEl || typeof Swiper === 'undefined') return;

    const slidesPerView = parseFloat(this.getAttribute('h5-show-num')) || 1.15;
    const spaceBetween = parseInt(this.getAttribute('h5-picture-gap'), 10) || 10;

    this._swiper = new Swiper(this.swiperEl, {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      grabCursor: true,
      watchSlidesProgress: true,
      on: {
        slideChange: () => this._setActiveTab(this._swiper.activeIndex),
        init: () => this._updateIndicator(),
      },
    });

    // 初始激活第一个 tab 并渲染指示条
    this._setActiveTab(0);

    // 监听窗口 resize 以刷新指示条位置
    this._resizeHandler = () => this._updateIndicator();
    window.addEventListener('resize', this._resizeHandler);

    // 图片加载完成后再校准一次
    const imgs = this.querySelectorAll('.sbc__img');
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', this._resizeHandler, { once: true });
      }
    });
  }

  _destroyMobile() {
    if (this._swiper) {
      try { this._swiper.destroy(true, true); } catch (e) { /* noop */ }
      this._swiper = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }
    // PC 下隐藏指示条宽度即可
    if (this.indicator) {
      this.indicator.style.width = '0px';
    }
  }

  _onTabClick(event) {
    const btn = event.currentTarget;
    const index = parseInt(btn.getAttribute('data-index'), 10) || 0;
    if (this._swiper) {
      this._swiper.slideTo(index);
    }
    this._setActiveTab(index);
  }

  _setActiveTab(index) {
    if (!this.tabs || this.tabs.length === 0) return;
    if (index < 0 || index >= this.tabs.length) return;
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this._updateIndicator();
  }

  _updateIndicator() {
    if (!this.indicator || !this.tabs || this.tabs.length === 0) return;
    const activeTab = this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0];
    if (!activeTab) return;
    const tabsRect = activeTab.parentElement.getBoundingClientRect();
    const rect = activeTab.getBoundingClientRect();
    const left = rect.left - tabsRect.left;
    this.indicator.style.width = rect.width + 'px';
    this.indicator.style.transform = `translateX(${left}px)`;
  }
}

if (!window.customElements.get('shop-by-category')) {
  customElements.define('shop-by-category', ShopByCategory);
}

// 自定义：Shop the look paginated
// PC: 翻页 + 激活；H5: 横滑 + 激活
class ShopTheLookPaginated extends HTMLElement {
  constructor() {
    super();
    this._currentPage = 0;
    this._activeTimer = null;
  }

  connectedCallback() {
    this._perPage = parseInt(this.dataset.perPage, 10) || 3;
    this._total = parseInt(this.dataset.total, 10) || 0;
    this._totalPages = Math.max(1, Math.ceil(this._total / this._perPage));

    this._track = this.querySelector('[data-stlp-track]');
    this._prevBtn = this.querySelector('[data-stlp-prev]');
    this._nextBtn = this.querySelector('[data-stlp-next]');
    this._scroll = this.querySelector('[data-stlp-scroll]');
    this._dots = Array.from(this.querySelectorAll('[data-stlp-dot]'));
    this._mobileItems = Array.from(this.querySelectorAll('[data-stlp-mobile-item]'));

    if (this._prevBtn) {
      this._prevBtn.addEventListener('click', () => this.goToPage(this._currentPage - 1));
    }
    if (this._nextBtn) {
      this._nextBtn.addEventListener('click', () => this.goToPage(this._currentPage + 1));
    }

    this._dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10) || 0;
        this.activateIndex(idx);
      });
    });

    this.goToPage(0);
  }

  goToPage(page) {
    if (!this._track) return;
    const clamped = Math.min(Math.max(0, page), this._totalPages - 1);
    this._currentPage = clamped;
    this._track.style.transform = `translateX(-${clamped * 100}%)`;
    if (this._prevBtn) this._prevBtn.disabled = clamped <= 0;
    if (this._nextBtn) this._nextBtn.disabled = clamped >= this._totalPages - 1;
  }

  activateIndex(index) {
    // 更新 dot 状态
    this._dots.forEach((d) => {
      d.setAttribute('aria-current', String(parseInt(d.dataset.index, 10) === index));
    });

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    if (isDesktop) {
      const targetPage = Math.floor(index / this._perPage);
      this.goToPage(targetPage);
      // 激活效果延迟一点，等翻页动画完成
      setTimeout(() => this._highlightCard(index), 200);
    } else {
      // H5：滚动到对应 item 的最左（不做激活高亮）
      const target = this._mobileItems.find(
        (it) => parseInt(it.dataset.index, 10) === index
      );
      if (target && this._scroll) {
        const left = target.offsetLeft - this._scroll.offsetLeft;
        this._scroll.scrollTo({ left, behavior: 'smooth' });
      }
    }
  }

  _highlightCard(index) {
    if (this._activeTimer) {
      clearTimeout(this._activeTimer);
    }
    this.querySelectorAll('.stlp-card.is-active').forEach((c) => c.classList.remove('is-active'));

    // 仅对 PC 端的卡片做激活（H5 端不需要）
    const cards = this.querySelectorAll(`.stlp__pc .stlp-card[data-index="${index}"]`);
    cards.forEach((c) => c.classList.add('is-active'));

    this._activeTimer = setTimeout(() => {
      cards.forEach((c) => c.classList.remove('is-active'));
    }, 1800);
  }
}

if (!window.customElements.get('shop-the-look-paginated')) {
  customElements.define('shop-the-look-paginated', ShopTheLookPaginated);
}

/* ============================================================
   Inline Mobile Menu Controller
   参考 merach 项目的内嵌式移动端菜单实现
   - 将 navigation-drawer 由弹窗改为内嵌渲染
   - 同步切换按钮 (.menu-switch-button) 的 .opened 状态（汉堡 <-> X）
   - 移动端点击外部关闭
   ============================================================ */
class InlineMenuController extends HTMLElement {
  constructor() {
    super();
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }
  connectedCallback() {
    this._tryInit();
  }
  disconnectedCallback() {
    document.removeEventListener('click', this._handleOutsideClick, true);
  }
  _tryInit(retry = 0) {
    const drawer = this.querySelector('navigation-drawer');
    const targetId = this.getAttribute('target') || (drawer && drawer.id);
    const button = targetId ? document.querySelector(`[aria-controls="${targetId}"]`) : null;
    if (!drawer || !button) {
      if (retry < 20) {
        setTimeout(() => this._tryInit(retry + 1), 50);
      }
      return;
    }
    this.drawer = drawer;
    this.button = button;
    // override shouldAppendToBody (keep drawer inline)
    try {
      Object.defineProperty(drawer, 'shouldAppendToBody', {
        get: () => false,
        configurable: true,
      });
    } catch (e) {
      /* ignore */
    }
    // Skip default clip-path / opacity transitions on mobile to avoid blank delay
    const originalShow = drawer._showTransition && drawer._showTransition.bind(drawer);
    const originalHide = drawer._hideTransition && drawer._hideTransition.bind(drawer);
    const isMobile = () => !window.matchMedia('(min-width: 1150px)').matches;
    drawer._showTransition = function (animate) {
      if (isMobile()) {
        this.style.opacity = '1';
        this.style.visibility = 'visible';
        const content = this.shadowRoot && this.shadowRoot.querySelector('[part="content"]');
        if (content) {
          content.style.clipPath = 'none';
          content.style.opacity = '1';
          Array.from(content.children).forEach((c) => {
            c.style.opacity = '1';
          });
        }
        this.classList.add('show-close-cursor');
        return { finished: Promise.resolve() };
      }
      return originalShow ? originalShow(animate) : { finished: Promise.resolve() };
    };
    drawer._hideTransition = function () {
      if (isMobile()) {
        this.style.opacity = '0';
        this.style.visibility = 'hidden';
        this.classList.remove('show-close-cursor');
        return { finished: Promise.resolve() };
      }
      return originalHide ? originalHide() : { finished: Promise.resolve() };
    };
    // sync button opened state
    drawer.addEventListener('dialog:after-show', (e) => {
      if (e.target !== drawer) return;
      button.classList.add('opened');
    });
    drawer.addEventListener('dialog:after-hide', (e) => {
      if (e.target !== drawer) return;
      button.classList.remove('opened');
    });
    // 兜底：drawer open 属性变化（有些动画路径可能错过 after-* 事件）
    const obs = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) {
        button.classList.add('opened');
      } else {
        button.classList.remove('opened');
      }
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    // 点击外部关闭（仅移动端内嵌模式）
    document.addEventListener('click', this._handleOutsideClick, true);
  }
  _handleOutsideClick(event) {
    if (!this.drawer || !this.button) return;
    if (!this.drawer.hasAttribute('open')) return;
    // 仅在移动端（菜单按钮可见时）处理
    if (window.matchMedia('(min-width: 1150px)').matches) return;
    const target = event.target;
    if (this.contains(target)) return;
    if (this.button.contains(target)) return;
    // 忽略弹层（如国家/语言切换的 popover、其他 dialog）内的点击，
    // 这些组件通常被 portal 到 body 之下，不在 drawer DOM 内，但属于 drawer 内触发的交互。
    if (target.closest && target.closest('x-popover, .popover, dialog-element, [role="dialog"]')) return;
    if (typeof this.drawer.hide === 'function') {
      this.drawer.hide();
    }
  }
}
if (!window.customElements.get('inline-menu-controller')) {
  customElements.define('inline-menu-controller', InlineMenuController);
}